import { RoleHost } from '../RoleHost';

export function TEWrapper() {
  return <RoleHost role="te" />;
}
